import { stringUtils } from '../../../../../utils/StringUtils';

const useLastMileModalConnector = () => {
  return {
    stringUtils: stringUtils(),
  };
};

export default useLastMileModalConnector;
